module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.13327/images/logos/yahoo.png"